<particles
  [params]="myParams"
  [style]="myStyle"
  [width]="width"
  [height]="height"
  class="position-fixed w-100 h-100 bg-dark-black"
  style="z-index: -1"
></particles>

<div>
  <app-header (toggleStatus)="toggleforHeader($event)"></app-header>
  <app-home id="home" (toggleStatus)="toggleforHeader($event)"></app-home>
  <app-portfolio id="portfolio"></app-portfolio>
  <app-about (toggleStatus)="toggleforHeader($event)" id="about"></app-about>
  <app-skills id="skills"></app-skills>
  <app-services id="services"></app-services>
  <app-contact id="contact"></app-contact>
  <app-footer></app-footer>
</div>
